// ========== 整页导航（C 方案） ==========
//
// 滚动未停稳时的误触保护：
// 手指滑动或惯性滚动期间页面内容在移动，用户点击瞄准的元素已经滑走，
// 点击会落在错误的位置（典型：落在固定不动的底部 tabbar 上，点A跳B）。
// 记录最近一次滚动时刻，滚动停止 250ms 内的导航请求直接忽略。
let lastScrollAt = 0

function markScroll() { lastScrollAt = Date.now() }

export function initScrollGuard() {
  window.addEventListener('scroll', markScroll, { passive: true, capture: true })
  window.addEventListener('touchmove', markScroll, { passive: true, capture: true })
}

function scrollSettling() { return Date.now() - lastScrollAt < 250 }

export function goto(url) {
  if (scrollSettling()) return
  window.location.href = url
}

export function gotoReplace(url) {
  if (scrollSettling()) return
  window.location.replace(url)
}
